import React from "react";
import { useDispatch, useSelector } from 'react-redux'
import { Radio, Grid, Message } from 'semantic-ui-react'
import PopUpIcon from '../formComponents/PopUpIcon'
import { saveValueBuildUpField, updateValueBuildUp } from './actions/ValueBuildUp'

export const ProrateWeight = ({ translate }) => {
  const prorateStrategy = useSelector((state) => state.ValueBuildUpReducer?.prorateStrategy) || ''
  const dispatch = useDispatch()
  return (
    <div className='ProrateWeight'>
      <span>{translate('PRORATE_WEIGHT', { ns: ['default', 'valueBuildUp'] })}</span>
      <Message className='ProrateWeight__content'>
        <div className='ProrateWeight__checkList'>
          <Grid>
            <Grid.Row>
              <Radio
                type='radio'
                name='prorateWeight'
                label={
                  <label>
                    {translate('PRORATE_WEIGHT_BASED_ON_VALUE', {
                      ns: ['default', 'valueBuildUp'],
                    })}
                  </label>
                }
                value={'ProrateWeightBasedOnValue'}
                checked={prorateStrategy === 'ProrateWeightBasedOnValue'}
                onClick={(e, data) => {
                  dispatch(updateValueBuildUp({ prorateStrategy: data.value }))
                  dispatch(saveValueBuildUpField(['prorateStrategy']))
                }}
              />
            </Grid.Row>
            <Grid.Row>
              <Radio
                type='radio'
                name='prorateWeight'
                label={
                  <label>
                    {translate('PRORATE_NET_WEIGHT_BASED_ON_GROSS_WEIGHT', {
                      ns: ['default', 'valueBuildUp'],
                    })}
                  </label>
                }
                value={'ProrateNettWeightBasedOnGrossWeight'}
                checked={prorateStrategy === 'ProrateNettWeightBasedOnGrossWeight'}
                onClick={(e, data) => {
                  dispatch(updateValueBuildUp({ prorateStrategy: data.value }))
                  dispatch(saveValueBuildUpField(['prorateStrategy']))
                }}
              />
            </Grid.Row>
            <Grid.Row>
              <Radio
                type='radio'
                name='prorateWeight'
                label={
                  <label>
                    {translate('PRORATE_GROSS_WEIGHT_BASED_ON_NET_WEIGHT', {
                      ns: ['default', 'valueBuildUp'],
                    })}
                  </label>
                }
                value={'ProrateGrossWeightBasedOnNettWeight'}
                checked={prorateStrategy === 'ProrateGrossWeightBasedOnNettWeight'}
                onClick={(e, data) => {
                  dispatch(updateValueBuildUp({ prorateStrategy: data.value }))
                  dispatch(saveValueBuildUpField(['prorateStrategy']))
                }}
              />
            </Grid.Row>
            <Grid.Row>
              <Radio
                type='radio'
                name='prorateWeight'
                label={
                  <label>
                    <PopUpIcon
                      icon='info circle'
                      popupText={translate('DO_NOT_PRORATE_POPUP')}
                    />
                    {translate('DO_NOT_PRORATE', { ns: ['default', 'valueBuildUp'] })}
                  </label>
                }
                value={'DoNotProrate'}
                checked={prorateStrategy === 'DoNotProrate'}
                onClick={(e, data) => {
                  dispatch(updateValueBuildUp({ prorateStrategy: data.value }))
                  dispatch(saveValueBuildUpField(['prorateStrategy']))
                }}
              />
            </Grid.Row>
          </Grid>
        </div>
      </Message>
    </div>
  )
}